var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgSmallSand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "118px",
    viewBox: "0 0 104 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 14\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,0 C49.673112,0 64,14.360362 64,32.0747664 C64,41.7358195 59.7386452,50.3992543 52.9971751,56.2796696 L32.0500895,78 L11.048967,56.3198412 C4.28080533,50.4387475 0,41.7578428 0,32.0747664 C0,14.360362 14.326888,0 32,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-53.1%",
    y: "-33.3%",
    width: "206.2%",
    height: "187.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 32,
    height: 31.9169995
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.4%",
    y: "-9.4%",
    width: "118.8%",
    height: "118.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.3142857,1.13989285 L25.1428572,1.13989285 L25.1428572,3.41967853 L27.3142857,3.41967853 L27.3142857,1.13989285 Z M13.6,5.71132143 L11.4285714,5.71132143 L11.4285714,7.9911071 L13.6,7.9911071 L13.6,5.71132143 Z M7.88571429,2.28275 L5.71428573,2.28275 L5.71428573,4.56253567 L7.88571429,4.56253567 L7.88571429,2.28275 Z M20.4571428,10.2590356 L18.2857143,10.2590356 L18.2857143,12.5388212 L20.4571428,12.5388212 L20.4571428,10.2590356 L20.4571428,10.2590356 Z M24,17.0983926 C27.2,17.0983926 29.7142857,14.5906284 29.7142857,11.3989284 C29.7142857,8.20722846 27.2,5.69946421 24,5.69946421 C22.6285714,5.69946421 21.2571428,6.15542133 20.2285714,7.06733561 L21.7142857,8.77717487 C22.4,8.32121775 23.2,7.97924988 24,7.97924988 C25.9428572,7.97924988 27.4285714,9.46111057 27.4285714,11.3989284 C27.4285714,13.3367463 25.9428572,14.8186069 24,14.8186069 L0.685714281,14.8186069 L0.685714281,17.0983926 L24,17.0983926 L24,17.0983926 Z M26.2857143,19.3781783 L9.6,19.3781783 L9.6,21.657964 L26.2857143,21.657964 C28.2285714,21.657964 29.7142857,23.1398247 29.7142857,25.0776425 C29.7142857,27.0154603 28.2285714,28.497321 26.2857143,28.497321 C24.3428571,28.497321 22.8571428,27.0154603 22.8571428,25.0776425 L20.5714286,25.0776425 C20.5714286,28.2693425 23.0857143,30.7771067 26.2857143,30.7771067 C29.4857143,30.7771067 32,28.2693424 32,25.0776425 C32,21.8859426 29.4857143,19.3781783 26.2857143,19.3781783 L26.2857143,19.3781783 Z M10.2857143,28.497321 L12.4571428,28.497321 L12.4571428,26.2175353 L10.2857143,26.2175353 L10.2857143,28.497321 Z M4.57142856,21.657964 L6.74285716,21.657964 L6.74285716,19.3781783 L4.57142856,19.3781783 L4.57142856,21.657964 L4.57142856,21.657964 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-22.4%",
    y: "-16.9%",
    width: "144.7%",
    height: "147.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7AD9\\u70B9\\u5730\\u56FE3\\u5907\\u4EFD",
    transform: "translate(-66.000000, -858.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14\\u5907\\u4EFD",
    transform: "translate(86.000000, 870.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408\\u5907\\u4EFD-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#66CB04",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u6C99\\u5C18\\u5907\\u4EFD-3",
    transform: "translate(16.000000, 16.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62",
    opacity: 0
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-5"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSmallSand);
export default __webpack_public_path__ + "static/media/img_small_sand.cc060edb0c4e7e2092d03e40b1cc3aa7.svg";
export { ForwardRef as ReactComponent };